const zxjc = [{
    path: 'zxjc_jh',
    name: 'zxjc_jh',
    component: () =>
              import('@/components/zxjc/zxjcjh'),
    meta: { title: '专项检查表计划', requireAuth: true, keepAlive: true, permission: true }
  },{
    path: 'zxjc_jcrw',
    name: 'zxjc_jcrw',
    component: () =>
              import('@/components/zxjc/jcrw'),
    meta: { title: '检查任务', requireAuth: true, keepAlive: true, permission: true }
  }
  ,{
    path: 'zxjc_jcx',
    name: 'zxjc_jcx',
    component: () =>
              import('@/components/zxjc/jcx'),
    meta: { title: '检查项', requireAuth: true, keepAlive: true, permission: true }
  }
  ,{
    path: 'zxjc_rwzt',
    name: 'zxjc_rwzt',
    component: () =>
              import('@/components/zxjc/rwzt'),
    meta: { title: '专项检查任务状态', requireAuth: true, keepAlive: true, permission: true }
  },{
    path: 'zxjc_pfb',
    name: 'zxjc_pfb',
    component: () =>
              import('@/components/zxjc/pfb'),
    meta: { title: '评分细则表', requireAuth: true, keepAlive: true, permission: true }
  },
  ]
  export default zxjc
  


// WEBPACK FOOTER //
// ./src/router/zxjc.js